import { render, staticRenderFns } from "./NotificationBase.vue?vue&type=template&id=ec69b8e6&"
import script from "./NotificationBase.vue?vue&type=script&lang=js&"
export * from "./NotificationBase.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBase.vue?vue&type=style&index=0&id=ec69b8e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports